import { render, staticRenderFns } from "./SelectRelation.vue?vue&type=template&id=a142c3ba&scoped=true"
import script from "./SelectRelation.vue?vue&type=script&lang=js"
export * from "./SelectRelation.vue?vue&type=script&lang=js"
import style0 from "./SelectRelation.vue?vue&type=style&index=0&id=a142c3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a142c3ba",
  null
  
)

export default component.exports